import React from "react";


const Backbtn = () => {
   

const Btnstyle = {
 width: '44px',
height: '44px',
background: '#FFFFFF',
border: 'none',
cursor: 'pointer',
display: 'flex',
alignItems: 'center',
justifyContent: 'center',
borderRadius: '50%',
transition: 'all 0.2s ease-out',
 }
  return (
    <button style={Btnstyle} >
      <svg
        width="16"
        height="13"
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.2794 11.7239L0.834959 6.27943M0.834959 6.27943L6.2794 0.834987M0.834959 6.27943L14.835 6.27943"
          stroke="#171717"
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  );
};

export default Backbtn;
